/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Hours } from "./Hours";
import {
  HoursFromJSON,
  HoursFromJSONTyped,
  HoursToJSON,
  HoursToJSONTyped,
} from "./Hours";
import type { ChangePickupDateReason } from "./ChangePickupDateReason";
import {
  ChangePickupDateReasonFromJSON,
  ChangePickupDateReasonFromJSONTyped,
  ChangePickupDateReasonToJSON,
  ChangePickupDateReasonToJSONTyped,
} from "./ChangePickupDateReason";

/**
 *
 * @export
 * @interface ChangePickupDateAndHoursRequest
 */
export interface ChangePickupDateAndHoursRequest {
  /**
   *
   * @type {string}
   * @memberof ChangePickupDateAndHoursRequest
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof ChangePickupDateAndHoursRequest
   */
  newPickupDate: string;
  /**
   *
   * @type {Hours}
   * @memberof ChangePickupDateAndHoursRequest
   */
  newPickupHours: Hours;
  /**
   *
   * @type {ChangePickupDateReason}
   * @memberof ChangePickupDateAndHoursRequest
   */
  reason: ChangePickupDateReason;
  /**
   *
   * @type {boolean}
   * @memberof ChangePickupDateAndHoursRequest
   */
  notifyCarrier: boolean;
}

/**
 * Check if a given object implements the ChangePickupDateAndHoursRequest interface.
 */
export function instanceOfChangePickupDateAndHoursRequest(
  value: object,
): value is ChangePickupDateAndHoursRequest {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("newPickupDate" in value) || value["newPickupDate"] === undefined)
    return false;
  if (!("newPickupHours" in value) || value["newPickupHours"] === undefined)
    return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  if (!("notifyCarrier" in value) || value["notifyCarrier"] === undefined)
    return false;
  return true;
}

export function ChangePickupDateAndHoursRequestFromJSON(
  json: any,
): ChangePickupDateAndHoursRequest {
  return ChangePickupDateAndHoursRequestFromJSONTyped(json, false);
}

export function ChangePickupDateAndHoursRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ChangePickupDateAndHoursRequest {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    newPickupDate: json["newPickupDate"],
    newPickupHours: HoursFromJSON(json["newPickupHours"]),
    reason: ChangePickupDateReasonFromJSON(json["reason"]),
    notifyCarrier: json["notifyCarrier"],
  };
}

export function ChangePickupDateAndHoursRequestToJSON(
  json: any,
): ChangePickupDateAndHoursRequest {
  return ChangePickupDateAndHoursRequestToJSONTyped(json, false);
}

export function ChangePickupDateAndHoursRequestToJSONTyped(
  value?: ChangePickupDateAndHoursRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    newPickupDate: value["newPickupDate"],
    newPickupHours: HoursToJSON(value["newPickupHours"]),
    reason: ChangePickupDateReasonToJSON(value["reason"]),
    notifyCarrier: value["notifyCarrier"],
  };
}
